import { AutomatorBuilderPublishSetting } from '../_base';
import { customElement } from 'lit/decorators.js';

// Import global utils
import { openWindow } from '@automator/shared/utils/open-window';
import { isEmpty } from '@automator/shared/utils/is-empty';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __ } from '@wordpress/i18n';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-publish-setting-total-times' )
export class AutomatorBuilderPublishSettingTotalTimes extends AutomatorBuilderPublishSetting {
	// Unique identifier for this setting.
	settingID = 'recipe_total_times';

	// Icon representing this setting in the UI.
	icon = 'hashtag';

	// Label displayed for this setting in the UI.
	label = escapeHTML( __( 'Total times', 'uncanny-automator' ) );

	// Define the helper text for the setting.
	// eslint-disable-next-line max-len
	helper = escapeHTML( __( 'The total number of times this recipe can run, regardless of the user.', 'uncanny-automator' ) );

	/**
	 * Defines the fields available within this setting. Each object in this array represents a field that can be configured by the user, including input type, label, and other attributes.
	 */
	fieldsDirectory = [
		{
			option_code: 'TIMES', // Unique code for the "Times" field.
			input_type: 'int', // Specifies the input type as integer.
			label: escapeHTML( __( 'Total allowed runs', 'uncanny-automator' ) ), // Label for the "Times" field.
			description: escapeHTML( __( 'Sets the maximum number of times this recipe can run overall, regardless of the user. Leave empty for unlimited runs.', 'uncanny-automator' ) ), // Field description shown to the user.
			placeholder: escapeHTML( __( 'Unlimited', 'uncanny-automator' ) ), // Placeholder text for empty value.
			min_number: 1, // Minimum value allowed for "Times" (must be 1 or greater).
			supports_tokens: false // Specifies that this field does not support tokens.
		}
	];

	/**
	 * Retrieves a readable version of the "Times" field value for display.
	 *
	 * @return {String|Number} The number of times set, or 'Unlimited' if no limit is defined.
	 */
	get readableValue() {
		// Get the value of the field "Times"
		const times = this.getFieldValue( 'TIMES' );

		// Check if "times" is empty or set to -1 (unlimited).
		if ( isEmpty( times ) || times == -1 ) {
			return escapeHTML( __( 'Unlimited', 'uncanny-automator' ) ); // Return 'Unlimited' if empty or unlimited.
		}

		// Convert "times" to an integer and return the value.
		return parseInt( times );
	}

	/**
	 * Opens the helper for the setting.
	 */
	helperCallback() {
		openWindow( {
			url: 'https://automatorplugin.com/knowledge-base/creating-a-recipe/?utm_source=uncanny-automator&utm_medium=in-plugin&utm_content=publish-metabox-recipe-type-question-icon#additional-settings:~:text=exactly%20as%20expected.-,Additional%20settings,-Before%20taking%20a',
			w: 450
		} )
	}
}
